module.exports = __webpack_public_path__ + "static/media/1_en.5bf4e410.png";